import { MapPinIcon as LocationMarkerIcon, VideoCameraIcon } from '@heroicons/react/24/outline';
import { isFuture } from 'date-fns';
import * as format from '../formatters';
import { FuneralServiceEvent, Organization } from '../types';

const ServiceLocation = (event) => {
  if (!event.venue) return;
  const { name } = event.venue;
  return <strong>{name}</strong>;
};

const ServiceStartTime = (event, organization) => {
  return (
    <span className="service-start-time">
      {isFuture(new Date(event!.start_at))
        ? format.dateTimeDisplayFuture(organization!.timezone, event!.start_at)
        : format.dateTimeDisplay(organization!.timezone, event!.start_at)}
    </span>
  );
};

const Event = ({ event, organization }: { event: FuneralServiceEvent; organization: Organization | undefined }) => {
  return (
    <div className="list-service-event">
      {event.is_streamed ? <VideoCameraIcon className="event-icon" /> : <LocationMarkerIcon className="event-icon" />}
      <strong>{event.name}</strong>
      {!event.is_venue_hidden ? <span> held at </span> : null}
      {!event.is_venue_hidden ? ServiceLocation(event) : null}
      {!event.is_date_hidden ? <span> - </span> : null}
      {!event.is_date_hidden ? ServiceStartTime(event, organization) : null}
    </div>
  );
};

const ListServiceEvents = ({ events, organization }: { events: FuneralServiceEvent[] | null | undefined; organization: Organization | undefined }) => (
  <div className="list-service-events"> {events?.map((event) => <Event key={event.name} event={event} organization={organization} />)}</div>
);

export default ListServiceEvents;
